import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/icon/fb-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-blog.png");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-dislike.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-like.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-down.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-up.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-tumblr.png");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-x.webp");
;
import(/* webpackMode: "eager" */ "/app/public/icon/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/avatar-blog.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/image/boc-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/dan-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/logo-nha-nha-khoa-hub.png");
;
import(/* webpackMode: "eager" */ "/app/public/image/nieng-rang-tham-my.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/trong-rang-implant.svg");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/blog-detail.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/blog-detail.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/blog/[slug]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/blog-search.js");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/blog-suggest.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/blog/blog-toc.js");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/detail-page-tool.js");
;
import(/* webpackMode: "eager" */ "/app/src/component/navigation/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/style/blog-detail.css");
